import request from './request';


/**
 * 获取车险保单列表信息
 */
export function getInsurancePolicy(params) {
    return request('/insurance/policy/list', {
        method: 'POST',
        params,
    });
}
/**
 * 获取保单详情
 */
export function getInsurancePolicyItem(params) {
    return request('/insurance/policy/item', {
        method: 'GET',
        params,
    });
}
